import React, { useEffect, useState } from 'react';
import './RequestInfo.css';
import { useLocation, Navigate } from 'react-router-dom';
import api from '../api';

const RequestInfo = () => {
  const [activeTab, setActiveTab] = useState('Pending');
  const [requests, setRequests] = useState([]);
  const location = useLocation();

  const fetchData = async () => {
    try {
      const res = await api.get('/getRequestInfo');
      if (res?.data?.data) {
        setRequests(res.data.data);
      }
    } catch (err) {
      console.error('Failed to fetch requests:', err);
    }
  };

  const handleStatusToggle = async (id, newStatus) => {
    try {
      const response = await api.post('/updateRequestInfo', {
         status: newStatus,
         id: id
      });

      if (response.data?.status?.statusCode === 'code-200'){
        fetchData();
      }
      else {
        console.error('Failed to update status');
      }
    } catch (err) {
      console.error('Error updating status:', err);
    }
  };

  const filteredRequests = requests.filter(
    (request) => request.status === activeTab
  );

  useEffect(() => {
    fetchData();
  }, []);

  if (!location.state?.fromLogin) {
    return <Navigate to="/requests/infoLogin" replace />;
  }

  return (
    <div className="request-info-container">
      <div className="tabs">
        <button
          className={activeTab === 'Pending' ? 'active' : ''}
          onClick={() => setActiveTab('Pending')}
        >
          Pending
        </button>
        <button
          className={activeTab === 'Completed' ? 'active' : ''}
          onClick={() => setActiveTab('Completed')}
        >
          Completed
        </button>
      </div>

      <div className="table-wrapper">
        <table className="request-table">
            <thead>
            <tr>
                <th>#</th>
                <th>Id</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>City</th>
                <th>Message</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {filteredRequests.length > 0 ? (
                filteredRequests.map((req, index) => (
                <tr key={req.id}>
                    <td>{index + 1}</td>
                    <td>{req.id}</td>
                    <td>{req.name}</td>
                    <td>{req.email}</td>
                    <td>{req.phoneNumber}</td>
                    <td>{req.city}</td>
                    <td>{req.message}</td>
                    <td>
                    <button
                        className="status-btn"
                        onClick={() =>
                        handleStatusToggle(
                            req.id,
                            activeTab === 'Pending' ? 'Completed' : 'Pending'
                        )
                        }
                    >
                        {activeTab === 'Pending' ? 'Complete' : 'Unresolve'}
                    </button>
                    </td>
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan="7" style={{ textAlign: 'center' }}>
                    No {activeTab} Requests
                </td>
                </tr>
            )}
            </tbody>
        </table>
      </div>

    </div>
  );
};

export default RequestInfo;
